const imageBaseUrl = "https://dotmedica.com";
const baseUrl = "";

export function pageUrl(subUrl: string): string {
  if (!subUrl) {
    return '#';
  }
  if (subUrl?.startsWith(baseUrl)) {
    return subUrl;
  }
  if (subUrl?.startsWith("/")) {
    return baseUrl + subUrl;
  }
  return baseUrl + "/" + subUrl;
}

export function imageUrl(subUrl: string): string {
  if (!subUrl) {
    return '#';
  }
  if (subUrl?.startsWith(imageBaseUrl)) {
    return subUrl;
  }
  if (subUrl?.startsWith("/")) {
    return imageBaseUrl + subUrl;
  }
  return imageBaseUrl + "/" + subUrl;
}
